import React from "react"
import {FieldFormElementProps} from "../../../../render/form-elemnent";
import FieldPopover_FormComponent from "../../../popover/components/form/form-component";


// const debug = "FieldTimeReported_FormElement"
const debug = false

export default function FieldTimeSpent_FormElement(props:FieldFormElementProps) {

    const onChange = (value:any) => {
        debug && console.log(debug, 'onChange', value, props.form)

        if (props.form) {
            props.form.onFormComponentValueChange(props.field.fieldId, value)
        }
    }

    const value = props.form.getValue(props.field.fieldId)


    return <FieldPopover_FormComponent className    = {props.className}
                                       field        = {props.field}
                                       value        = {value}
                                       disabled     = {props.disabled}
                                       model        = {props.model}
                                       options      = {props.options}
                                       onChange     = {onChange} />
}